import React from 'react';
import {Switch, Route, Link} from 'react-router-dom';
import "../../../assets/css/common/AllCss.css";
import config from '../../../assets/js/conf/config.js';
import {request} from '../../../assets/js/libs/request.js';
import {lazyImg, setScrollTop,localParam} from '../../../assets/js/utils/util.js';		//图片懒加载	
import SearchComponent from '../../../components/search/search.js';
import UpRefresh from "../../../assets/js/libs/uprefresh.js";
import searchBook from './book.js';
import searchJinN from './jinrang.js';
import searchKeChen from './kecheng.js';


export default class collegeComponent extends React.Component{
	constructor(props){
		super(props);
		this.state = {
			Screen: false,
			status: 1,
			keywords: localStorage['searchKeywords'] != undefined? localStorage['searchKeywords']: "",
			fenyuanArr: [],
			zhibo: null
		};
		this.Screen = true;
		this.searchStyle = {display:"none"};
		this.oUpRefresh = null;
		this.curPage = 1;
		this.maxPage = 0;
		this.offsetBottom = 50;
	}
    componentDidMount(){
    	this.getJson();
       
        setScrollTop(global.scrollTop.index);
        window.addEventListener("scroll", this.isScren.bind(this),false);
    }
    getJson(val){
    	let data = {
    		"param": {
			    "keyword": val?val:this.state.keywords
			},
			"pageIndex": 1,
			"pageSize": 10
    	}
    	request(config.baseUrl+'api/Study/S008', 'post', data).then(res=>{
            if (res.code == 0){
                this.setState({
                	fenyuanArr: res.data.items
                })
                localStorage['search'] = 1;
        		//localStorage['searchKeywords'] = this.state.keywords;
        		this.maxPage = res.data.totalItems;
				this.getScrollPage();
            }
        });
    }
    getScrollPage() {
		this.oUpRefresh = new UpRefresh({
			"curPage": this.curPage,
			"maxPage": this.maxPage,
			"offsetBottom": this.offsetBottom
		}, curPage => {
			if((curPage-1) * 10 >= this.maxPage){
				return
			}
			let data = {
	    		"param": {
				    "keyword": this.state.keywords
				},
				"pageIndex": curPage,
				"pageSize": 10
	    	}
			request(config.baseUrl+'api/Study/S008', 'post', data).then(res=>{
	            if (res.data.items.length>0){
	            	let searchArr = this.state.fenyuanArr;
					for(let i = 0; i < res.data.items.length; i++) {
						searchArr.push(res.data.items[i]);
					}
					this.setState({
						fenyuanArr: searchArr
					})
	            }
	       });
		})
	}
    componentWillUnmount(){
    	//界面离开的时候
		this.Screen = false;
		window.removeEventListener("scroll", this.isScren.bind(this));
		this.oUpRefresh = null;
		
		this.setState=(state,callback)=>{
            return;
        }
	}
    getIsLocalSearch(val) {
		this.kwords = val;
		this.setState({
			keywords: val,
		})
		this.setState(this.searchStyle = {
			display: "none"
		});
		this.getJson(val);
		//this.props.history.replace("/goods/searcgDetail");
		//localStorage['searchKeywords'] = val;
	}
    goBack(){
    	if (localStorage['bottomIndex'] == 1){
            this.props.history.replace('/home/index');
        }else if (localStorage['bottomIndex'] == 2){
            this.props.history.replace('/home/cart');
        }else if (localStorage['bottomIndex'] == 3){
            this.props.history.replace('/home/college');
        }
//else{
//          this.props.history.goBack();
            localStorage['search'] = 2;
//        }
    }
    isScren(){
    	if(this.Screen){
    		let isScreen = document.documentElement.scrollTop || document.body.scrollTop;
    		global.scrollTop.index = isScreen;
	    	if(isScreen>=100){
	    		this.setState({
	    			Screen : true
	    		});
	    	}else{
	    		this.setState({
	    			Screen : false
	    		});
	    	}
    	}
    }
    LeftIcon(path){
    	this.props.history.push(path)
    }
    searchClick(display){
    	this.setState(
    		this.searchStyle = display
    	)
    }
    componentWillReceiveProps(newProps){
    	let name = newProps.location.pathname;
    	if(name === '/searcgDetail/kechen'){
    		this.setState({
	        	status: '1'
	        })
    	}else if(name === '/searcgDetail/book'){
    		this.setState({
	        	status: '2'
	        })
    	}else if(name === '/searcgDetail/jinN'){
    		this.setState({
	        	status: '3'
	        })
    	}
    }
    render(){
        return(
            <div className={'college'}>
                <div className={this.state.Screen?'search-header search-header red-bg':'search-header search-header'} onClick={this.searchClick.bind(this,{display:"block"})}>
                    <div className={'search-wrap'}>
                        <div className={'search-icon'}></div>
                        <div className={'search-text'}>{this.state.keywords != ''?this.state.keywords:'请输入'}</div>
                    </div>
                    <div className={'login-wrap'} onClick={this.goBack.bind(this)}>
	                	取消
                    </div>
                </div>
                {
//              	<div className={'search-nav'}>
//	                	<Link to='/searcgDetail/kechen'>
//				    		<div className={this.state.status == '1'?'active':''} >
//		                		课程
//		                		<span></span>
//		                	</div>
//			        	</Link>
//			        	<Link to='/searcgDetail/book'>
//				    		<div className={this.state.status == '2'?'active':''}>
//		                		电子书
//		                		<span></span>
//		                	</div>
//			        	</Link>
//			        	<Link to='/searcgDetail/jinN'>
//				    		<div className={this.state.status == '3'?'active':''}>
//		                		锦囊
//		                		<span></span>
//		                	</div>
//			        	</Link>
//	                </div>
                }
                
                <div>
	                <Switch>
	                	<Route path='/searcgDetail/kechen' component={searchKeChen}></Route>
	                	<Route path='/searcgDetail/book' component={searchBook}></Route>
	                	<Route path='/searcgDetail/jinN' component={searchJinN}></Route>
	                </Switch>
                </div>
                <div className={'found'}>
                	<div className={'found-title-wrap'}>
                	{
                		this.state.fenyuanArr.length>0?
                		this.state.fenyuanArr.map((item2,index2) => {
                			return(
                				<div className={'found-item0 col'} onClick={this.LeftIcon.bind(this, '/video/other?olId='+item2.merchandiseId)} key={index2}>
		                			<div className={'found-img0'}>
		                            	<img src={item2.Ol_Logo != ""?item2.Ol_Logo:require('../../../assets/images/video/pic_cover.png')} />
		                            </div>
		                            <div className={'found-txt'}>
			                            <div className={'found-title0'}>{item2.Ol_Name}</div>
			                            <div className={"found-text0"}>{item2.TeacherName}</div>
		                            </div>
		                        </div>
                			)
                		})
                        :<div className={"null"}>暂无课程内容!</div>
                	}
                		
                	</div>
                </div>
                
                <SearchComponent 
                	searchStyle={this.searchStyle} 
                	display={this.searchClick.bind(this)} 
                	isLocal="1"
                	isLocalSearch={this.getIsLocalSearch.bind(this)}
                	kwords={this.state.keywords}
                	>
                </SearchComponent>
            </div>
        );
    }
}